export default __webpack_public_path__ + "static/media/Lasting Faith Boots.4706823c.jpg";